var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00004 0.833328C2.69587 0.833328 0.833374 2.69583 0.833374 5C0.833374 7.30416 2.69587 9.16666 5.00004 9.16666C7.30421 9.16666 9.16671 7.30416 9.16671 5C9.16671 2.69583 7.30421 0.833328 5.00004 0.833328ZM7.08337 6.49583L6.49587 7.08333L5.00004 5.58749L3.50421 7.08333L2.91671 6.49583L4.41254 5L2.91671 3.50416L3.50421 2.91666L5.00004 4.4125L6.49587 2.91666L7.08337 3.50416L5.58754 5L7.08337 6.49583Z",
    fill: "fillCurrent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNotificationIcon);
export default __webpack_public_path__ + "static/media/close-notification-icon.ed54df65.svg";
export { ForwardRef as ReactComponent };